import { AllAssetsResponse, AssetResponseModel, AssetsClassificationDropDownResponse, AssetsClassificationResponseModel, AssetsResponse } from '@gtpl/shared-models/asset-management';
import { Body, Controller, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AssetsClassificationService } from './assets-classification.service';
import { AssetsClassificationDTO } from './dto/assets-classification-dto';
import { AssetsClassificationByIdReq } from './dto/assets-classification-id-request';
import { assetsClassificationDtoActive } from './dto/assets-classification-active-deactive';
import { ApiTags } from '@nestjs/swagger';

@ApiTags('assets-classification')
@Controller('assets-classification')
export class AssetsClassificationController {
    constructor(private assetsClassificationService: AssetsClassificationService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    @Post('/createAssetsClassification')
    async createAssetsClassification(@Body() assetsClassificationDTO: AssetsClassificationDTO): Promise<AssetsClassificationResponseModel> {
        try {
            return await this.assetsClassificationService.CreateAssetsClassification(assetsClassificationDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsClassificationResponseModel, error);
        }
    }

    @Post('/updateAssetsClassification')
    async updateAssetsClassification(@Body() assetsClassificationDTO: AssetsClassificationDTO): Promise<AssetsClassificationResponseModel> {
        try {
            return await this.assetsClassificationService.CreateAssetsClassification(assetsClassificationDTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsClassificationResponseModel, error);
        }
    }

    @Post('/getAllAssetsClassificationDropDown')
    async getAllAssetsClassificationDropDown(): Promise<AssetsClassificationDropDownResponse> {
        try {
            return await this.assetsClassificationService.getAllAssetsClassificationDropDown();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsClassificationDropDownResponse, error);
        }
    }

    @Post('getRecordByAssetsClassificationId')
    async getRecordByAssetsClassificationId(@Body() id: AssetsClassificationByIdReq): Promise<AssetResponseModel> {
        try {
            return await this.assetsClassificationService.getRecordByAssetsClassificationId(id.assetsClassificationId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetResponseModel, error);
        }
    }

    @Post('getAllAssetsClassification')
    async getAllAssetsClassification(): Promise<AllAssetsResponse> {
        try {
            return await this.assetsClassificationService.getAllAssetsClassification();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllAssetsResponse, error);
        }
    }

    @Post('activateorDeactivateAssets')
    async activateorDeactivateAssets(@Body() AssetsAct: assetsClassificationDtoActive): Promise<AssetsResponse> {
        try {
            return await this.assetsClassificationService.activateorDeactivateAssets(AssetsAct);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsResponse, error);
        }
    }

}
